type Callback = (...args: unknown[]) => void

interface DebouncedFunction {
    (...args: unknown[]): void

    cancel: () => void
}

function debounce(callback: Callback, delay: number): DebouncedFunction {
    let timeoutId: NodeJS.Timeout | undefined

    const debounced: DebouncedFunction = (...args: unknown[]) => {
        if (timeoutId) {
            clearTimeout(timeoutId)
        }

        timeoutId = setTimeout(() => {
            callback(...args)
        }, delay)
    }

    debounced.cancel = () => {
        if (timeoutId) {
            clearTimeout(timeoutId)
            timeoutId = undefined
        }
    }

    return debounced
}

export { debounce }
